import { Biometric, BiometricType } from "../../models/entities/biometrics.model";
import TrackHealthList from "./TrackHealthList";
import TrackHealthSummary from "./TrackHealthSummary";

const TrackHealthContent = ({ type, data }: { type: BiometricType; data: Biometric[] }) => {
	return (
		<div className="">
			<TrackHealthSummary
				type={type}
				data={data}
			/>
			<TrackHealthList
				type={type}
				data={data}
			/>
		</div>
	);
};
export default TrackHealthContent;
